export default __webpack_public_path__ + "static/media/facebook_message.745b7c65.svg";